export enum ControlType {
    label = "label",
    link = "link",
    date = "date",
    mobile = "mobile",
    amount = "amount"
}